import React, { useEffect, useState } from 'react';
import './styles.css'
import NotificationToast from './components/notification/NotificationToast';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import TermsOfUse from './components/sections/TermsOfUse';
import CosmicOrbitLoader from '../components/CosmicOrbitLoader';
import { dynamicLoader } from '../helpers/helpers';

const TermsOfUsePage = () => {
  const [showPreloader, setShowPreloader] = useState(true);
  document.title = "Webs2PDF";
  useEffect(() => {
    dynamicLoader.addScripts();
    setTimeout(() => {
      setShowPreloader(false);
    }, 3000);
  });
  if (showPreloader) {
    return <CosmicOrbitLoader />;
  }
  return (
    <>
      <NotificationToast />
      <Navbar isIndex={false} />
      <TermsOfUse />
      <Footer />
    </>
  );
};

export default TermsOfUsePage;
